import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_9 = { class: "list-group" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = ["disabled"]

import { computed, toRef } from 'vue'
    import type { ListSelectionDialogViewModel } from '@common/Components/ListSelectionDialog'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ListSelectionDialog',
  props: {
    viewModel: {}
  },
  emits: ["update-value"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.isOpened === true)
    const title = computed(() => vm.value?.title)

    // ---------------- methods ----------------

    function updateValue(val: string)
    {
        vm.value.selectedValue =
            vm.value.selectedValue === val
                ? null
                : val
    }

    function confirm()
    {
        emit('update-value', vm.value.selectedValue, vm.value.id)
    }

    function close()
    {
        vm.value.isOpened = false
    }

return (_ctx: any,_cache: any) => {
  return (opened.value === true)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(title.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                (vm.value.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(vm.value.description), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vm.value.items, (item) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: item.key,
                      class: _normalizeClass(['list-group-item', 'list-group-item-action', { 'active': item.value == vm.value.selectedValue }]),
                      onClick: ($event: any) => (updateValue(item.value))
                    }, [
                      _createTextVNode(_toDisplayString(item.label) + " ", 1 /* TEXT */),
                      (item.description != null)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_11, [
                            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                            _createTextVNode(_toDisplayString(item.description), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 10 /* CLASS, PROPS */, _hoisted_10))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", {
                  onClick: confirm,
                  type: "button",
                  class: "btn btn-primary",
                  disabled: vm.value.valueRequired && vm.value.selectedValue == null
                }, "Confirm", 8 /* PROPS */, _hoisted_13)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})